import * as React from 'react';
import { Properties } from './properties/CategorySelectContainerProps';
import ErrorAsync from '../../../../BaseComponents/ErrorComponent/ErrorAsync';
import CategoryPicker from '../../../general-content/components/CategoryPicker';

/**
 * TODO move to shared folder
 */
const CategorySelectContainer: React.FunctionComponent<Properties> = (props) => {
	const { categories, selectedCategory, inputId, onCategorySelect, t } = props;

	const safeSelectedCategory = !selectedCategory || selectedCategory.id === undefined ? null : selectedCategory;

	const handleCategoryChange = (selection: any) => {
		onCategorySelect(selection);
	};

	return (
		<>
			<CategoryPicker
				id={inputId || 'category-select'}
				label=''
				categories={categories || []}
				selectedValue={safeSelectedCategory}
				onChange={handleCategoryChange}
				placeholder={t('select_category')}
				isMulti={false}
				disabled={false}
			/>
			<ErrorAsync t={t} errorType='category_id' />
		</>
	);
};

export default CategorySelectContainer;
